import React from "react";
import PageListBanner from "../../components/layouts/PageListBanner";

/**
 * V4 Saved Search list banner — same shell as the Search page banner
 * (height, gradient, decorative marks, padding), with list-page copy.
 */
export default function SavedSearchListBanner() {
  return (
    <PageListBanner
      testId="saved-search-list-banner"
      title="Your saved searches"
      subtitle="View and manage your saved searches"
    />
  );
}
